'use strict';

(function () {
  'use strict';

  angular.module('msSignUp', ['msUtility', 'msCore', 'msAssessment', 'msProfile', 'msActivityServices', 'smoothScroll', 'msTracker', 'msOnboarding']).run(['$rootScope', 'smoothScroll', 'wellnessSvc', 'activitySvc', 'pageTitleSvc', 'eventTrackingSvc', '$location', '$cookies', '$log', '$timeout', 'NotifyingSvc', function ($rootScope, smoothScroll, wellnessSvc, activitySvc, pageTitleSvc, eventTrackingSvc, $location, $cookies, $log, $timeout, NotifyingSvc) {
    var TIME_TO_OPEN_LOGOUT_MODAL = 3480000; // 58 minutes = 3 480 000 milliseconds
    $rootScope.updateRootToken = _updateRootToken;
    $rootScope.setReAuthToken = _setReAuthToken;
    $rootScope.isMobileWebView = false;
    $rootScope.mobilePlatform = null;
    $rootScope.reAuthToken = null;
    $rootScope.token = null;
    $rootScope.telehealthTriggered = false;
    $rootScope.webViewPostMessages = {
      login: {
        path: 'login',
        parameters: {}
      },
      home: {
        path: 'home',
        parameters: {
          token: $rootScope.token,
          reAuthToken: $rootScope.reAuthToken
        }
      },
      telehealth: {
        path: 'TELEHEALTH_GETHELP',
        parameters: {
          token: $rootScope.token,
          reAuthToken: $rootScope.reAuthToken
        }
      },
      agreements: {
        path: 'agreements',
        parameters: {}
      }
    };

    // Send postMessage to mobile app webview
    $rootScope.sendWebViewPostMessage = function (postMessageKey) {
      var postMessagePayload = $rootScope.webViewPostMessages[postMessageKey] ? $rootScope.webViewPostMessages[postMessageKey] : null;

      // If path home AND telehealthTriggered
      // replace payload with telehealth
      if (postMessagePayload && postMessagePayload.path === 'home' && $rootScope.telehealthTriggered === true) {
        postMessagePayload = $rootScope.webViewPostMessages.telehealth;
      }

      if ($rootScope.isMobileWebView && postMessagePayload) {
        // iOS
        try {
          window.webkit.messageHandlers.appInterface.postMessage(postMessagePayload, window.location.origin);
        } catch (error) {
          $log.debug('iOS postMessage error: ', error);
        }
        // Android
        try {
          window.appInterface.postMessage(JSON.stringify(postMessagePayload));
        } catch (error) {
          $log.debug('Android postMessage error: ', error);
        }
      }
    };

    activate();

    function activate() {
      eventTrackingSvc.init();

      // send pageviews to google analytics
      eventTrackingSvc.registerEventListeners();
      wellnessSvc.translatePrefix = 'onboarding';
      $rootScope.$on('$stateChangeStart', function () {
        smoothScroll($('body')[0], {
          duration: 300
        });
      });

      //wire up global event subscribers from activities
      activitySvc.registerEventlisteners();
      //wire up global event subscriber for page title changes
      pageTitleSvc.registerEventListeners();
      // Check for webview query param
      _setIsMobileWebView();
    }

    function _setIsMobileWebView() {
      var locationSearch = $location.search();
      if (!locationSearch) {
        return;
      }
      if (locationSearch.isMobileWebView) {
        $rootScope.isMobileWebView = true;
        _updateRootToken();
      }
      if (locationSearch.mobilePlatform) {
        // Set mobile platform
        $rootScope.mobilePlatform = locationSearch.mobilePlatform === 'android' ? 'android' : 'ios';
      }
    }

    function _setReAuthToken(reAuthToken) {
      $rootScope.reAuthToken = reAuthToken;
      if (!$rootScope.isMobileWebView) {
        $timeout.cancel($rootScope.reauthTimer);
        $rootScope.reauthTimer = $timeout(function () {
          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
            templateUrl: 'core/templates/logout-modal.html',
            controller: 'LogoutModalCtrl',
            inputs: {}
          });
        }, TIME_TO_OPEN_LOGOUT_MODAL);
      }

      _updateRootToken();
    }

    function _updateRootToken() {
      var token = $cookies.get('token');
      var reAuthToken = $rootScope.reAuthToken;

      $rootScope.token = token ? token : null;
      $rootScope.reAuthToken = reAuthToken ? reAuthToken : null;

      _updateWebViewPostMessages();
    }

    function _updateWebViewPostMessages() {
      $rootScope.webViewPostMessages.home.parameters = {
        token: $rootScope.token,
        reAuthToken: $rootScope.reAuthToken
      };
    }
  }]);
})();